import { render } from "./InputSearchText.vue?vue&type=template&id=6922782b"
import script from "./InputSearchText.vue?vue&type=script&lang=js"
export * from "./InputSearchText.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/backoffice.callmewine.co.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__